import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, TemplateRef } from '@angular/core';

/**
 * 自定义按钮的配置
 * - `icon` 雪碧图，上部分是正常状态，下部分是激活状态
 * - `tooltipTitle` 默认状态 -- 鼠标移动上去的提示语
 * - `activeTooltipTitle` 激活状态 -- 鼠标移动上去的提示语
 * - `click:(item,itemConfig) => void` 点击之后的回调
 * - `active:(item : any)=>boolean` 根据item的具体字段决定是否激活
 */
export interface BtnConfig {
  icon?: string;
  tooltipTitle?: string;
  activeTooltipTitle?: string;
  click?: (item: any, itemConfig: any) => void;
  active?: (item: any) => boolean;
  hidden?: (item: any, itemConfig: any) => boolean;
  ['key']?: any;
}
/**
 * 评论源数据
 * - `userName` 用户名
 * - `createTime` 评论时间
 * - `replyList` 回复列表
 *    + `fromUserName` 用户名
 *    + `replyContent` 回复内容
 *    + `createTime` 回复时间
 */
export interface Data {
  userName?: string;
  content?: string;
  createTime?: string;
  replyList?: Reply[];
  ['key']?: any;
}
/** 回复源数据 */
export interface Reply {
  fromUserName?: string;
  toUserName?: string;
  replyContent?: string;
  createTime?: string;
  ['key']?: any;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-comment-pannel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './icc-comment-pannel.component.html',
  styleUrls: ['./icc-comment-pannel.component.less'],
})
export class IccCommentPannelComponent {
  /** 自定义标题 */
  @Input() titleTemplate: TemplateRef<void>;
  /**
   * 最大允许显示的评论数
   * - 如果传 `-1` 表示不限制
   */
  @Input() maxReplay = 2;
  /** 评论源数据 */
  @Input() data: any = {};

  /** 是否隐藏操作栏 */
  @Input() hiddenBtns: boolean = false;

  /** 评论配置 */
  @Input() commentConfig?: BtnConfig[] = [];
  /** 回复的配置 */
  @Input() replyConfig?: BtnConfig[] = [];

  /** 选择状态改变的回调 */
  @Output() checkChangeHandle = new EventEmitter<any>();

  /** 点击 -- 加载更多 */
  moreReplay(): void {
    this.maxReplay = -1;
  }
  /** 点击 -- 改变选择状态 */
  checkChange(value: boolean, item?: any): void {
    this.checkChangeHandle.next(value);
  }
  /** 辅助 -- 操作按钮 */
  handleBtnTooltip(data: any, btn: BtnConfig) {
    if (btn.active) {
      return btn.active(data) ? btn.activeTooltipTitle : btn.tooltipTitle;
    }
    return btn.tooltipTitle;
  }
}
